export class ShipRoundTripInfo {

  // @Pattern(regexp = "^$|^[0-9]*$", message = "Please enter a numeric roundtrip interval.")
  autoRoundTripInterval: string;

  // @Size(min = 0, max = 100, message = "Ship port must be between 0 and 100 characters.")
  shipPort: string;

  // @Size(min = 0, max = 10, message = "Ship DSSN must be between 0 and 10 digits.")
  // @Pattern(regexp = "^[0-9]*$", message = "Ship DSSN must be between 0 and 10 digits.")
  dssn: string;

  // @Size(min = 0, max = 10, message = "Ship MARINE DSSN must be between 0 and 4 digits.")
  // @Pattern(regexp = "^[0-9]*$", message = "Ship MARINE DSSN must be between 0 and 4 digits.")
  marineDssn: string;

  // @Size(min = 1, max = 10, message = "Ship TYCOM must be between 1 and 10 characters.")
  shipTycom: string;

  // @Size(min = 1, max = 6, message = "Ship CINC must be between 1 and 6 characters.")
  shipCinc: string;

  // @Pattern(regexp = "[NY]", message = "Ship Skip Cash Link Flag (Y/N).")
  skipClinkInd: string;

}
